import { render } from "./Inquire.vue?vue&type=template&id=489ca38a&scoped=true"
import script from "./Inquire.vue?vue&type=script&lang=js"
export * from "./Inquire.vue?vue&type=script&lang=js"

import "@/assets/css/layout_request.css?vue&type=style&index=0&id=489ca38a&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489ca38a"]])

export default __exports__